/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { TaxRateFinderDialogComponent } from './tax-rate-finder-dialog.component';

export const taxRateFinderDialogRoute = createDialogRoute({
  component: TaxRateFinderDialogComponent,
});
